<template>
  <div class="s-footer-contact">
    <address class="s-footer-contact__address">
      <span>{{ trSite("client.general.contact_address_street") }}</span>
      <span>{{ trSite("client.general.contact_address_city") }}</span>
    </address>

    <div class="s-footer-contact__actions">
      <a
        class="s-footer-contact__link"
        :href="`tel:${trSite('client.general.contact_phone_number')}`"
      >
        <i class="fa-regular fa-phone s-footer-contact__icon" />
        {{ trSite("client.general.contact_phone_number") }}
      </a>
      <a
        class="s-footer-contact__link"
        :href="`mailto:${trSite('client.general.contact_email')}`"
      >
        <i class="fa-regular fa-envelope s-footer-contact__icon" />
        {{ trSite("client.general.contact_email") }}
      </a>
      <button
        v-if="ysaAvailable"
        class="s-footer-contact__link"
        type="button"
        @click="ysaToggle"
      >
        <i class="fa-regular fa-messages s-footer-contact__icon" />
        {{ tr("main_site.layout.footer_contact_chat") }}
      </button>
    </div>

    <SFooterSocials class="s-footer-contact__socials" />
  </div>
</template>

<script setup lang="ts">
import { useI18nMainSite, useI18nMainSiteLayout } from "@solvari/translations";

import useYouShouldAsk from "@/composables/useYouShouldAsk";
import SFooterSocials from "@/organisms/footer/SFooterSocials.vue";

const props = defineProps<{
  websiteType?: "mainSite" | "mySolvari";
}>();

const { tr } = useI18nMainSiteLayout();
const { tr: trSite } = useI18nMainSite();
const { ysaToggle, ysaAvailable } = useYouShouldAsk(props.websiteType);
</script>

<style lang="postcss">
.s-footer-contact {
  @apply flex flex-col gap-2;

  &__address {
    @apply flex flex-col text-base not-italic text-white;
  }

  &__actions {
    @apply flex flex-col items-start gap-2;
  }

  &__link {
    @apply inline-flex cursor-pointer items-center text-base text-white no-underline gap-2;

    &:hover {
      @apply underline;
    }
  }

  &__icon {
    @apply h-4 w-4;
  }

  &__socials {
    @apply -ml-3 mt-1;
  }
}
</style>
